import type React from "react";
import ComponentLoader from "../Loaders/ComponentLoader";
import Modal from "../Modals/Modal";

interface ModalProps {
  handleClose: () => void;
  modalId: string;
  confirmDelete: () => void;
  isDeleteLoading: boolean;
}
const ConfirmDeleteModal: React.FC<ModalProps> = ({
  confirmDelete,
  handleClose,
  modalId,
  isDeleteLoading,
}) => {
  return (
    <Modal
      cancelButtonLabel="Cancel"
      confirmButtonLabel="Confirm"
      handleCancel={handleClose}
      handleConfirm={confirmDelete}
      headerTitle="Delete Item"
      modalBoxClassName="!h-fit"
      modalId={modalId}
      showCloseIcon={false}
    >
      <div className="flex flex-col items-center justify-center">
        <p className="text-center text-xl font-bold text-red-300">
          Are you sure you want to delete this item?
        </p>
        {isDeleteLoading ? (
          <div className="my-5">
            <ComponentLoader
              ellipsesLoaderProps={{
                contentContainerStyle: "bg-green",
              }}
            />
          </div>
        ) : null}
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal;
